<template>
    <v-overlay :absolute="false" :opacity="0.8" :value="showOverlay" :z-index="999" >
        <v-progress-circular
        :size="70"
        :width="7"
        color="white"
        indeterminate
        ></v-progress-circular>    
    </v-overlay>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    computed: {
        ...mapMutations('overlay', ['toggleOverlay']),
        showOverlay: {
            get () {
                return this.$store.state.overlay.overlay;
            },
            set (val) {
                this.toggleOverlay(val);                       
            }
        },
    }
}
</script>

<style>
</style>